import { render, staticRenderFns } from "./piclist.vue?vue&type=template&id=1ca1d118&scoped=true&"
import script from "./piclist.vue?vue&type=script&lang=js&"
export * from "./piclist.vue?vue&type=script&lang=js&"
import style0 from "./piclist.vue?vue&type=style&index=0&id=1ca1d118&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1d118",
  null
  
)

export default component.exports